export default "__VITE_ASSET__4621e8d0__"